import { MIN_OR_SEC_IN_HOUR } from 'consts';

import { config } from '../../config';

export const convertWidthToMinutesWidth = (screenWidth: number) =>
  Math.ceil((screenWidth / config.hourScale) * MIN_OR_SEC_IN_HOUR);
